import { firebase } from '@firebase/app';
import ReduxSagaFirebase from 'firebase-redux-saga';

import '@firebase/auth';
import '@firebase/database';
import '@firebase/storage';

// import { uploadString } from '@firebase/storage';
import config from '../config/config';

// import firebaseConfig from './config';

// const firebaseApp = firebase.initializeApp(firebaseConfig);
const firebaseApp = firebase.initializeApp(config.FIREBASE_CONFIG);

export const firebaseDb = firebase.database();
export const firebaseSocialAuth = firebase.auth();
export const rsf = new ReduxSagaFirebase(firebaseApp);
export const firebaseAuth = rsf.auth;
export const firebaseStorage = firebase.storage();
// export const uploadToStorage = (ref, str) => uploadString(ref, str, 'base64');

export default firebaseApp;
